























import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import {TableViewConfig} from '@/ts/interfaces/TableConfigTypes';

@Component({
  components: {
    FlexibleTable,
  },
  computed: {
    ...mapGetters({
      getTargetedRecipients: 'Recipients/getTargetedRecipients',
    }),
  },
})
export default class TargetedRecipientList extends Vue {
  public tableEntity: string = 'TargetedRecipientList';

  constructor() {
    super();
  }

  get columns(): any {
    return [
      {
        name: 'property_title_number',
        label: this.$t('general.unit-id', 'Unit Id'),
        align: 'left',
        field: 'property_id',
        sortable: true,
        required: true,
      },
      {
        name: 'name',
        label: this.$t('general.name', 'Name'),
        align: 'left',
        sortable: true,
        required: false,
        filter: false,
        field: (row: any) => {
          return row.first_name + ' ' + row.family_name;
        },
      },
      {
        name: 'email',
        label: this.$t('general.email', 'E-mail'),
        align: 'left',
        field: 'email',
        sortable: true,
        required: true,
      },
      {
        name: 'address',
        label: this.$t('general.address', 'Address'),
        align: 'left',
        field: 'address',
        sortable: true,
        required: true,
      },
    ];
  }


  get defaultTableConfig(): TableViewConfig {
    return {
      visibleColumns: [
        'id',
        'name',
        'email',
        'phone_number',
        'address',
      ],
    };
  }

}
